import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useIsPlatformAdmin } from "@/hooks/usePlatformSummary";

interface Props {
  children: React.ReactNode;
}

const Spinner = () => (
  <div className="flex h-screen items-center justify-center">
    <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" />
  </div>
);

export const PlatformAdminGuard: React.FC<Props> = ({ children }) => {
  const { user, loading } = useAuth();
  const { data: isAdmin, isLoading, isError, isFetched } = useIsPlatformAdmin();

  if (loading) return <Spinner />;
  if (!user) return <Navigate to="/auth" replace />;
  if (isLoading || isError) return <Spinner />;
  if (isFetched && !isAdmin) return <Navigate to="/controller" replace />;

  return <>{children}</>;
};
